import React, { useEffect, useRef } from "react";
import { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { IonIcon, IonList } from "@ionic/react";
import { useHistory } from "react-router";

import { AuthContext } from "../../context/AuthContext";

//
import "./categories.styles.css";

//
const CategoriesPopOver = (props: ICategoreiesPopoverProps) => {
  const { addToCart } = useContext(AuthContext);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const history = useHistory();

  const addItemToCart = (item: any) => {
    addToCart(item.id, item.name, uuidv4());

    //
    history.push("/personale/attesa");
  };

  const [searchText, setSearchText] = React.useState("");

  useEffect(() => {
    inputRef?.current?.focus?.();
  }, []);

  //
  return (
    <IonList className="search-inner-content categories-services-list">
      <p style={{ marginTop: "-2px" }}>
        SE NON HAI TROVATO LA PRATICA CERCALA SOPRA
      </p>

      <div
        className="searchable-select-input"
        style={{
          marginBottom: "1rem",
        }}
      >
        <input
          type="text"
          id="search-text"
          className="navbar-search navbar-search-mobile"
          placeholder="Cerca un servizio"
          defaultValue={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          autoFocus
          tabIndex={0}
          ref={inputRef}
        />
        <IonIcon name="search-outline" className="input-search-icon" />
      </div>

      {props?.arrayList
        ?.filter((item) =>
          item.name.toLowerCase().includes(searchText.toLowerCase())
        )
        ?.map((item: any, index: number) => (
          <li
            onClick={() => addItemToCart(item)}
            className="categories-services-items"
            key={index}
          >
            <span className="categories-services-items">{item.name}</span>
          </li>
        ))}
    </IonList>
  );
};

//
interface ICategoreiesPopoverProps {
  arrayList: any[];
  selectedCategory: string | null;
  onDismiss: () => void;
}

export default CategoriesPopOver;
